import { omitBy } from 'lodash';
import React from 'react';
import { useRemainingWidth, WidthProvider } from '../width-context';
export function ColumnItem(props) {
    const { align, containerBackgroundColor, cssClass, padding, paddingBottom, paddingLeft, paddingRight, paddingTop, verticalAlign, } = props;
    const remainingWidth = useRemainingWidth({
        padding,
        paddingLeft,
        paddingRight,
    });
    // NOTE: client side and server side react style attribute merging behaves differently.
    // So to make it 1:1 in both cases if property doesn't exist we don't need to set it.
    const paddings = omitBy({
        padding,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft,
    }, (value) => !value);
    return (React.createElement("tr", null,
        React.createElement("td", { align: align, valign: verticalAlign, className: cssClass, style: {
                background: containerBackgroundColor,
                fontSize: '0px',
                ...paddings,
                wordBreak: 'break-word',
            } },
            React.createElement(WidthProvider, { value: remainingWidth }, props.children))));
}
//# sourceMappingURL=column-item.js.map